import { MutateOptions } from "@tanstack/react-query";
import { axiosInstance } from "~/lib/axios-instance";
import { useMutationWithAirbrake } from "~/lib/hooks/use-mutation-with-airbrake";

interface Feedback {
  rating: string;
  content: string;
  url: string;
}

const postFeedback = async ({
  rating,
  content,
  url,
}: Feedback): Promise<Feedback> => {
  const response = await axiosInstance.post(`/api/v0/feedbacks`, {
    rating: rating,
    content: content,
    url: url,
  });
  return response.data;
};

export const useFeedback = ({
  onSuccess,
  onError,
}: Pick<MutateOptions<Feedback, Error, Feedback>, "onSuccess" | "onError">) => {
  const feedbackMutation = () => {
    return {
      mutationKey: ["feedback"],
      mutationFn: async (feedback: Feedback) => await postFeedback(feedback),
      onSuccess: onSuccess,
      onError: onError,
    };
  };

  const { mutate, status, error } = useMutationWithAirbrake({
    ...feedbackMutation(),
  });

  return {
    mutate,
    status,
    error,
  };
};
